import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-servicio',
  templateUrl: './btn-nuevo-tipo-servicio.component.html',
  styleUrls: ['./btn-nuevo-tipo-servicio.component.css']
})
export class BtnNuevoTipoServicioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
